'use strict'

define [], () ->
  ($rootScope, $scope, $http, RentappService, RENTAPPLICATION_API_URL, $uibModalInstance) ->
    $scope.is_loading = false
    $scope.deposit_1 = 0.01
    $scope.deposit_2 = 0.01
    $scope.error_message = ""
   
    $scope.verify_deposits = () ->
      if not $scope.deposit_1 or not $scope.deposit_2
        return
      $scope.is_loading = true
      $http.post "#{RENTAPPLICATION_API_URL}/api/v3/referrers/verify_bank_account/",
        amount_1: $scope.deposit_1
        amount_2: $scope.deposit_2
      .then (resp) ->
        $uibModalInstance.close(resp.data)
      .catch (err) ->
        console.log(err)
      .finally ->
        $scope.is_loading = false
      


// WEBPACK FOOTER //
// ./components/dashboard/referral/modals/verify_deposit.coffee